module.exports = "/_next/static/images/coming-soon-solved-8114a341b8ee9bd7a576ed1cba5a3e3c.png";